/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { ExcQuotemediaV1EodPriceTaskEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const EXC_QUOTEMEDIA_V1_EOD_PRICE_TASK_EVENT_ENTITY_NAME = 'exc.quotemedia.v1.EodPriceTaskEvent';
export const excQuotemediaV1EodPriceTaskEventEntity = new schema.Entity<ExcQuotemediaV1EodPriceTaskEvent>(EXC_QUOTEMEDIA_V1_EOD_PRICE_TASK_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: ExcQuotemediaV1EodPriceTaskEvent) => `${entity.metadata?.eventId}` });

